import request from '@utils/request.js'

export function getitemlist (parameter) {
    return request({
      url: '/auth/rest/user/get_page',
      method: 'get',
      params: parameter
    })
  }
  export function removeUser(parameter){
    return request({
        url: '/auth/rest/user/remove',
        method: 'post',
        data: parameter
      })
  }
  export function getUser(parameter){
    return request({
        url: '/auth/rest/user/get/'+`${parameter}`,
        method: 'get'
      })
  }
  export function getAllEnterprise(){
    return request({
        url: '/auth/rest/enterprise/get_all',
        method: 'get'
      })
  }
  export function updateUser(parameter){
    return request({
        url: '/auth/rest/user/update',
        method: 'post',
        data: parameter
      })
  }
  export function addUser(parameter){
    return request({
        url: '/auth/rest/user/add',
        method: 'post',
        data: parameter
      })
  }
  export function getUserPageList (parameter) {
    return request({
      url: '/auth/rest/user/get_page',
      method: 'get',
      params: parameter
    })
  }
  export function getFtp (parameter) {
    return request({
      url: '/auth/rest/user/get_ftp_user/'+`${parameter}`,
      method: 'get',
    })
  }
  
  export function addFtp(parameter){
    return request({
        url: '/auth/rest/user/add_ftp_user',
        method: 'post',
        data: parameter
      })
  }
  
  export function updateFtp(parameter){
    return request({
        url: '/auth/rest/user/update_ftp_user',
        method: 'post',
        data: parameter
      })
  }

  export function editPwd(parameter){
    return request({
        url: '/auth/rest/user/change_pwd',
        method: 'post',
        data: parameter
      })
  }

  export function getCurrentOwnUserList(){
    return request({
      url: '/auth/rest/user/get_current_own_user_list',
      method: 'get',
    })
  }